import React from 'react';

const RotatedSquare = () => {
  return (
    <svg
      width="31"
      height="15"
      viewBox="0 0 31 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.353554 7.5L7.5 0.353554L14.6464 7.5L7.5 14.6464L0.353554 7.5Z"
        stroke="black"
        strokeWidth="0.5"
      />
      <path
        d="M8.35355 7.5L15.5 0.353554L22.6464 7.5L15.5 14.6464L8.35355 7.5Z"
        stroke="black"
        strokeWidth="0.5"
      />
      <path
        d="M16.3536 7.5L23.5 0.353554L30.6464 7.5L23.5 14.6464L16.3536 7.5Z"
        stroke="black"
        strokeWidth="0.5"
      />
    </svg>
  );
};

export default RotatedSquare;
